import { useParams } from 'react-router-dom'

import { RouteParams } from '@/routes/routes'

export default function useShopId() {
  const { shopId } = useParams<RouteParams['SHOP']>()
  return shopId
}
